import styled from 'styled-components';

export const AddNoteContainer = styled.div`
  display: flex;
  flex-direciton: column;
  justify-contents: center;
  align-items: center;
  padding: 20px;
  margin: auto;
`;

export const NewNoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const AddNoteField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const AddNoteLabel = styled.label`
  font-weight: bold;
  margin-bottom: 4px;
`;

export const AddNoteInput = styled.input`
  width: 100%;
  padding: 8px;
  font-size: 14px;
`;

export const AddNoteTextarea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px;
  font-size: 14px;
  resize: vertical;
`;

export const AddNoteButton = styled.button`
  font-family: 'Open Sans Condensed';
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  background-color: #000;
  border: none;
  border-radius: 4px;
  height: 45px;
  width: 150px;
  align-self: center;

  &:hover {
    color: #000;
    background-color: #fff;
    border: 1px solid #000;
  }
`;

export const AddNoteCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;